import ConfirmJwt from 'pages/authentication/confirm-jwt';

export default function ConfirmJwtPage() {
  return <ConfirmJwt />;
}
